import { render, staticRenderFns } from "./ChangeActivationType.vue?vue&type=template&id=b8aeb084&"
import script from "./ChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports